/*
|--------------------------------------------------------------------------
| Exports
|--------------------------------------------------------------------------
*/

export enum Key {
    Space = ' ',
    A = 'a',
    B = 'b',
    C = 'c',
    D = 'd',
    E = 'e',
    F = 'f',
    G = 'g',
    W = 'w',
    R = 'r',
    Q = 'q',
    S = 's',
}

let _keyDown: Record<string, boolean> = {};
let _keyUp: Record<string, boolean> = {};
let _keyPressed: Record<string, boolean> = {};
let _keyReleased: Record<string, boolean> = {};

/*
|--------------------------------------------------------------------------
| Private Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {Key}
 */
function _getKeyFromEvent(event: KeyboardEvent): Key
{
    for (const which in Key) {
        if (Key[which as keyof typeof Key] === event.key) {
            return Key[which as keyof typeof Key];
        }
    }

    return null;
}

/**
 * @return {void}
 */
export function _onKeyDown(event: KeyboardEvent): void
{
    let key = _getKeyFromEvent(event);

    _keyPressed[key] = !_keyDown[key];
    _keyDown[key] = true;
    _keyUp[key] = false;
}

/**
 * @return {void}
 */
export function _onKeyUp(event: KeyboardEvent): void
{
    let key = _getKeyFromEvent(event);

    _keyReleased[key] = !_keyUp[key];
    _keyDown[key] = false;
    _keyUp[key] = true;
}

/*
|--------------------------------------------------------------------------
| Public Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {boolean}
 */
export function KeyDown(key: Key): boolean
{
    return !!_keyDown[key];
}

/**
 * @return {boolean}
 */
export function KeyUp(key: Key): boolean
{
    return !!_keyUp[key];
}

/**
 * @return {boolean}
 */
export function KeyPressed(key: Key): boolean
{
    return !!_keyPressed[key];
}

/**
 * @return {boolean}
 */
export function KeyReleased(key: Key): boolean
{
    return !!_keyReleased[key];
}

/**
 * @return {void}
 */
export function KeyboardReset(): void
{
    _keyDown = {};
    _keyUp = {};
    _keyPressed = {};
    _keyReleased = {};
}

/**
 * @return {void}
 */
export function KeyboardPostUpdate(): void
{
    _keyPressed = {};
    _keyReleased = {};
}

/**
 * @return {void}
 */
export function KeyboardInit(): void
{
    document.body.addEventListener('keydown', _onKeyDown);
    document.body.addEventListener('keyup', _onKeyUp);
}
